<div *ngIf="loading.isLoading; else loaded;">
  <app-loading [loadingText]="loading.message"></app-loading>
</div>

<ng-template #loaded>

  <div class="content-header">

    <div class="section-title">My Courses</div>

    <div class="section-description">
      Courses that you have been assigned to map are listed below. Please note that you may not be asked to map all
      the courses you teach.
    </div>


  </div>

  <!-- <div class="ui main container"> -->

  <div>

    <app-load-error [loadError]="loadError" *ngIf="loadError; else noErrors">
    </app-load-error>

    <ng-template #noErrors>

      <div class="course-list-group">

        <h3 class="ui header light section-header">Active Courses</h3>
        <div class="section-description">
          Map the courses listed below.
        </div>


        <table class="ui table course-list-table" *ngIf="courseListActive.length > 0">
          <thead>
            <tr>
              <th>
                Course
              </th>
              <th class="review-col">
                Curriculum Review/Program
              </th>
              <th class="status-col">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let course of courseListActive">
              <td>
                <div class="course-title">
                  <a [routerLink]="['/user/courses', course.id]"> {{ course.code }} {{ course.number }} {{
                      course.name}} {{course.section}}</a>
                </div>
                <div class="semester-name">{{ course.semester }} {{ course.year }} </div>
              </td>
              <td class="review-col">
                <div>{{course.review}}</div>
                <div class="program-name">{{course.program}}</div>
                <div class="faculty-name">{{course.faculty}}</div>
              </td>
              <td class="status-col">
                <div class="course-status">


                  <i class="ui icon exclamation assigned" *ngIf="course.status == 'Assigned'"></i>
                  <i class="ui icon checkmark submitted" *ngIf="course.status == 'Submitted'"></i>
                  <i class="ui icon arrow right in-progress" *ngIf="course.status == 'In Progress'"></i>

                  {{ course.status}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>




        <div *ngIf="courseListActive.length == 0">
          <div class="ui message">
            <p>You do not have courses.</p>
          </div>
        </div>

      </div>

      <div class="course-list-group">

        <h3 class="ui header light section-header">Archived Courses</h3>

        <div class="section-description">
          Courses you have mapped in previous years are listed below.
        </div>


        <table class="ui table course-list-table" *ngIf="courseListArchived.length > 0">
          <thead>
            <tr>
              <th>
                Course
              </th>
              <th class="review-col">
                Curriculum Review/Program
              </th>
              <th class="status-col">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let course of courseListArchived">
              <td>
                <div class="course-title">
                  <a [routerLink]="['/user/courses', course.id]"> {{ course.code }} {{ course.number }} {{
                      course.name}} {{course.section}}</a>
                </div>
                <div class="semester-name">{{ course.year }} {{ course.semester }}</div>
              </td>
              <td class="review-col">
                <div>{{course.review}}</div>
                <div class="program-name">{{course.program}}</div>
                <div class="faculty-name">{{course.faculty}}</div>
              </td>
              <td class="status-col">
                <div class="course-status">
                  Archived
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="courseListArchived.length == 0">
          <div class="ui message">
            <p>You do not have any archived courses.</p>
          </div>
        </div>

      </div>


      <div class="course-list-group" *ngIf="currentUser.id == 1">

        <h3 class="ui header light section-header">Deleted Courses</h3>

        <div class="section-description">
          Courses you have mapped in previous years are listed below.
        </div>


        <table class="ui table course-list-table" *ngIf="courseListDeleted.length > 0">
          <thead>
            <tr>
              <th>
                Course
              </th>
              <th class="review-col">
                Curriculum Review/Program
              </th>
              <th class="status-col">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let course of courseListDeleted">
              <td>
                <div class="course-title">
                  <a [routerLink]="['/user/courses', course.id]"> {{ course.code }} {{ course.number }} {{
                      course.name}} {{course.section}}</a>
                </div>
                <div class="semester-name">{{ course.year }} {{ course.semester }}</div>
              </td>
              <td class="review-col">
                <div>{{course.review}}</div>
                <div class="program-name">{{course.program}}</div>
                <div class="faculty-name">{{course.faculty}}</div>
              </td>
              <td class="status-col">
                <div class="course-status">
                  Deleted
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="courseListDeleted.length == 0">
          <div class="ui message">
            <p>You do not have any archived courses.</p>
          </div>
        </div>

      </div>

    </ng-template>

  </div>


</ng-template>


<!-- </div> -->